import React from "react";
import { Theme } from "@theme";
import { StyleSheet, View } from "react-native";
import { Image } from 'expo-image';
import { useTheme } from "@react-navigation/native";
import { defaultImage } from "@assets";

export const GroupAvatar = ({profiles}: {profiles: {id: string, avatarUrl: string | undefined}[]}) => {
    const theme = useTheme()
    const styles = getStyles(theme)

    const ICON_SIZE = 26
    const STEP = 15 // décalage horizontal
    const displayCount = Math.min(profiles.length, 3)
    const containerWidth = ICON_SIZE + (displayCount - 1) * STEP

    return(
        <View style={[styles.groupAvatarContainer, {width: containerWidth}]}>
            {profiles.slice(0, 3).map((p, idx) => (
              <Image key={p.id} source={p.avatarUrl? { uri: p.avatarUrl } : defaultImage} style={[styles.groupAvatar, { left: idx * 15, zIndex: 10 - idx }]} cachePolicy="memory-disk" contentFit="cover" />
            ))}
          </View>
    )
}

const getStyles = (theme: Theme) => StyleSheet.create({
    groupAvatarContainer: {
        height: 26,
        marginRight: theme.spacing.md,
      },
      groupAvatar: {
        position: 'absolute',
        width: 26,
        height: 26,
        borderRadius: 13,
        left: 0,
        top: 0,
        borderWidth: 2,
        borderColor: theme.colors.white,
      },
})